import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MenuService } from './menu.service';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { getUser } from '@app/store/user/user.reducer';
import { IUser, User } from '@app/store/user';
import { State } from '@app/store';
import { takeUntil } from 'rxjs/operators';
import { FeatureFlagService } from 'app/shared/feature-flag/feature-flag.service';
import { PingAuthenticationService } from '@aa-techops-ui/ping-authentication';
import { TitleBarComponent } from '../title-bar/title-bar.component';

@Component({
    selector: 'app-aa-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    imports: [
        CommonModule,
        RouterLink,
        RouterLinkActive,
        TitleBarComponent
    ]
})
export class NavBarComponent implements OnInit, OnDestroy {
    private readonly store = inject(Store<State>);
    private readonly router = inject(Router);
    private readonly featureFlag = inject(FeatureFlagService);
    private readonly authService = inject(PingAuthenticationService);
    public readonly menuService = inject(MenuService);

    currentActiveRoute = '/home';
    isReportManagementAccess = false;
    destroy$: Subject<void> = new Subject<void>();
    iodFlag = false;
    isGeneralMgr = false;
    canViewFillOutReport = false;

    ngOnInit(): void {
        this.store.select(getUser).pipe(takeUntil(this.destroy$)).subscribe(user => this.loadUser(user));

        this.authService.OnSignInComplete.pipe(takeUntil(this.destroy$)).subscribe(_ => {
            this.featureFlag.hasFeatureFlag('FLAG_IOD_HISTORY').pipe(takeUntil(this.destroy$)).subscribe(f => this.iodFlag = f);
        });

        this.router.events
            .pipe(takeUntil(this.destroy$)).subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.updateRoute(event.url);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    loadUser(user: IUser) {
        if (!user) { return; }
        this.menuService.setPrivileges(user);
        this.isReportManagementAccess = User.hasPrivilege(user, 'WEB_HISTORY_MANAGEMENT_ACCESS');
        this.isGeneralMgr = user.profileId === 7;
    }
    
    updateRoute(route: string) {
        this.currentActiveRoute = route;
    }
}
